import {
  FaBookOpen,
  FaClock,
  FaFileLines,
  FaHandHoldingHeart,
  FaPen,
  FaPenToSquare,
  FaUsers,
} from "react-icons/fa6";
import {
  ADMISSION_ASSESSMENT_STATUS,
  ASSESSMENT_CYCLE_PURPOSE,
  ASSESSMENT_CYCLE_TASK,
  GRADE,
  QUESTION_CRITERIA,
  STATUS,
  studentStatus,
  studentSupportLevel,
  TIME_EXTENSION_TYPE,
} from "./constants";

export const studentManagement_Headers = [
  { label: "ID", value: "schoolId", isSortable: true, dataStyle: { whiteSpace: "nowrap" } },
  { label: "Grade", value: "grade", isSortable: true },
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Home Language", value: "language", isSortable: true },
  { label: "Support", value: "studentSupportLevel", isSortable: true },
  { label: "L", value: "listening", isSortable: true },
  { label: "S", value: "speaking", isSortable: true },
  { label: "R", value: "reading", isSortable: true },
  { label: "W", value: "writing", isSortable: true },
  { label: "Overall", value: "overAllScore", isSortable: true },
  { label: "Cycle", value: "cycle", dataStyle: { whiteSpace: "nowrap" } },
  // A single total keeps the table readable; the per-domain split is on hover.
  { label: "Flags", value: "flags", isSortable: true },
  { label: "Status", value: "studentStatus", isSortable: true, dataStyle: { whiteSpace: "nowrap" } },
  { label: "", value: "action", dataStyle: { whiteSpace: "nowrap" } },
];
export const reviewDataHeaders = [
  { label: "", value: "checkBox" },
  { label: "ID", value: "schoolId", dataStyle: { whiteSpace: "nowrap" } },
  { label: "Grade", value: "grade", isSortable: true },

  // { label: "Student", value: "name", isSortable: true },
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Home Language", value: "language", isSortable: true },
  { label: "Support", value: "studentSupportLevel", isSortable: true },
  { label: "L", value: "listeningScore", isSortable: true },
  { label: "S", value: "speakingScore", isSortable: true },
  { label: "R", value: "readingScore", isSortable: true },
  { label: "W", value: "writingScore", isSortable: true },
  { label: "Overall", value: "overAllScore", isSortable: true },
  { label: "Cycle", value: "cycle", dataStyle: { whiteSpace: "nowrap" } },
  { label: "Status", value: "studentStatus", isSortable: true, dataStyle: { whiteSpace: "nowrap" } },
  { label: "", value: "action", dataStyle: { whiteSpace: "nowrap" } },
];
export const studentManagement_tabsOptions = [
  { label: "Students", value: "students" },
  { label: "Class", value: "roster" },
];
export const studentManagement_sortOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Pending", value: "pending" },
  { label: "Archive", value: "archive" },
];
export const campus = [
  { label: "Campus 1", value: "campus1" },
  { label: "Campus 2", value: "campus2" },
  { label: "Campus 3", value: "campus3" },
  { label: "Campus 4", value: "campus4" },
];
export const myBookingsHeaders = [
  {
    label: "Service Name",
    value: "name",
  },
  {
    label: "Service Provider",
    value: "serviceProvider",
  },
  {
    label: "Staff Member",
    value: "staffMember",
  },
  {
    label: "Date",
    value: "createdAt",
  },
  {
    label: "Duration",
    value: "duration",
  },
  {
    label: "Amount",
    value: "amount",
  },
  {
    label: "",
    value: "action",
  },
];
export const ReviewHeaders = [
  { label: "Customer Name", value: "name" },
  { label: "Service(s)", value: "services" },
  { label: "Rating", value: "rating" },
  { label: "Date", value: "date" },
  { label: "Time", value: "time" },
  { label: "Actions", value: "actions" },
];
export const reviewTableHeaders = [
  { label: "Service Name", value: "serviceName" },
  { label: "Time Slots", value: "timeSlots" },
  { label: "Time", value: "time" },
  { label: "Rating", value: "rating" },
];

export const dashboard_filter_options = [
  { label: "Campus 1", value: "campus 1" },
  { label: "Campus 2", value: "campus 2" },
  { label: "Campus 3", value: "campus 3" },
];
export const barchart_dropdown_options2 = [
  { label: "Fall", value: "fall" },
  { label: "Spring", value: "spring" },
  { label: "Summer", value: "summer" },
  { label: "Winter", value: "winter" },
];

export const grade_level_header = [
  {
    label: "Grade",
    value: "grade",
    dataStyle: {
      backgroundColor: "#d6e7f5",
      borderRadius: "10px 0px 0px 10px",
    },
    footerStyle: {
      backgroundColor: "#d6e7f5",
      color: "var(--primary-text-color)",
    },
  },
  {
    label: "High",
    value: "high",
    footerStyle: {
      backgroundColor: "#d6e7f5",
      color: "var(--primary-text-color)",
    },
  },
  {
    label: "Medium",
    value: "medium",
    footerStyle: {
      backgroundColor: "#d6e7f5",
      color: "var(--primary-text-color)",
    },
  },
  {
    label: "Low",
    value: "low",
    footerStyle: {
      backgroundColor: "#d6e7f5",
      color: "var(--primary-text-color)",
    },
  },
  {
    label: "Total",
    value: "total",
    footerStyle: {
      backgroundColor: "#d6e7f5",
      color: "var(--primary-text-color)",
    },
  },
];

export const checkboxOptions = [
  { label: "Listening", color: "#8F80DA" },
  { label: "Speaking", color: "#1A8CFF" },
  { label: "Reading", color: "#35C32D" },
  { label: "Writing", color: "#FF1B08" },
  { label: "Overall", color: "#58E9AE" },
];
export const admission_pending_header = [
  { label: "Student", value: "student" },
  { label: "Grade", value: "grade" },
  { label: "Assessment", value: "assessment" },
  { label: "Assessment Date", value: "assessmentDate" },
  { label: "Listening", value: "listening" },
  { label: "Speaking", value: "speaking" },
  { label: "Reading", value: "reading" },
  { label: "Writing", value: "writing" },
  { label: "Overall Score", value: "overallScore" },
  { label: "Status", value: "status" },
  { label: "", value: "action" },
];

export const all_students_header = [
  { label: "Grade", value: "grade" },
  { label: "First Name", value: "firstName" },
  { label: "Last Name", value: "lastName" },
  { label: "Home Language", value: "language" },
  { label: "Support", value: "studentSupportLevel" },
  { label: "L", value: "listening" },
  { label: "S", value: "speaking" },
  { label: "R", value: "reading" },
  { label: "W", value: "writing" },
  { label: "Overall", value: "overAllScore" },
  { label: "Cycle", value: "cycle" },
  { label: "Status", value: "studentStatus" },
  { label: "", value: "action" },
];

export const evaluations_header = [
  { label: "Student", value: "student" },
  { label: "Grade", value: "grade" },
  { label: "Assessment Band", value: "assessmentBand" },
  { label: "Purpose", value: "purpose" },
  { label: "Speaking Status", value: "speakingStatus" },
  { label: "Writing Status", value: "writingStatus" },
  { label: "Evaluator", value: "evaluator" },
  { label: "Assessment Date", value: "assessmentDate" },
  { label: "", value: "action" },
];
// Each cycle renders its own table, so the widths are fixed percentages (they
// add up to 100) and the table uses a fixed layout. Without that, every table
// sizes its columns from its own rows and the cycles stop lining up.
export const assessmentCycleHeaders = [
  {
    label: "Test Session Name",
    value: "name",
    width: "25%",
  },
  {
    label: "Assessment Task",
    value: "task",
    width: "15%",
  },

  {
    label: "Phase",
    value: "phase",
    width: "13%",
  },

  {
    label: "Report",
    value: "report",
    width: "13%",
  },

  {
    label: "Campus",
    value: "campus",
    width: "14%",
  },
  {
    label: "Students",
    value: "students",
    width: "9%",
  },
  {
    label: "",
    value: "actions",
    width: "11%",
  },
];
export const assessmentTabs = [
  {
    label: "Prepare",
    value: "prepare",
  },
  {
    label: "Conduct",
    value: "conduct",
  },
  {
    label: "Standardize",
    value: "standardize",
  },
  {
    label: "Evaluate",
    value: "evaluate",
  },
  // The stored phase names are older than this order: after Evaluate a cycle
  // is in phase "communicate", which is now the FC Insights step (Generate),
  // and releasing moves it to "insights", which is now the Communicate step.
  // Left as they are so existing cycles need no migration.
  {
    label: "FC Insights",
    value: "communicate",
  },
  {
    label: "Communicate",
    value: "insights",
  },
];
export const assesssmentCyclePrepareHeaders = [
  {
    label: "Test Session Name",
    value: "session",
  },
  {
    label: "Assessment Task",
    value: "assessment",
  },
  {
    label: "Cycle",
    value: "cycle",
  },
  {
    label: "Purpose",
    value: "purpose",
  },
  {
    label: "Campus",
    value: "campus",
  },
  {
    label: "Students",
    value: "students",
  },
];
export const assessmentRosterFieldsHeaders = [
  {
    label: "Date",
    value: "date",
    type: "date",
  },
  {
    label: "Venue",
    value: "venue",
  },
  {
    label: "Conductor",
    value: "conductor",
  },
];
export const assessmentPrepareHeaders = [
  {
    label: "ID Number",
    value: "id",
  },
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Grade",
    value: "grade",
  },
  {
    label: "Support Level",
    value: "supportLevel",
  },
  {
    label: "Status",
    value: "status",
  },
];
export const standardizeCycleFieldHeaders = [
  {
    label: "Test Session Name",
    value: "session",
  },
  {
    label: "Assessment Task",
    value: "assessment",
  },
  {
    label: "Cycle",
    value: "cycle",
  },
  {
    label: "Purpose",
    value: "purpose",
  },
  {
    label: "Campus",
    value: "campus",
  },
  {
    label: "Students",
    value: "students",
  },
  {
    label: "Standardization Percentage",
    value: "standardize",
    type: "percentage",
  },
];
export const standardizeAssessmentHeaders = [
  { label: "ID", value: "schoolId" },
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Venue",
    value: "venue",
  },
  {
    label: "Grade",
    value: "grade",
  },
  {
    label: "Support Level",
    value: "studentSupportLevel",
  },
];
export const evaluationsCycleFieldsHeaders = [
  {
    label: "Test Session Name",
    value: "session",
  },
  {
    label: "Assessment Task",
    value: "assessment",
  },
  {
    label: "Cycle",
    value: "cycle",
  },
  {
    label: "Purpose",
    value: "purpose",
  },
  {
    label: "Campus",
    value: "campus",
  },
  {
    label: "Students",
    value: "students",
  },
  {
    label: "Standardization Percentage",
    value: "standardize",
    type: "percentage",
  },
];
export const evaluationsAssessmentHeaders = [
  {
    label: "Grade",
    value: "grade",
  },
  {
    label: "Student",
    value: "student",
  },
  { label: "Assessment Date", value: "createdAt" },
  {
    label: "Evaluator",
    value: "evaluator",
  },
  {
    label: "Speaking Status",
    value: "speakingStatus",
  },
  {
    label: "Writing Status",
    value: "writingStatus",
  },
  {
    label: "",
    value: "actions",
  },
];
export const campusManager_header = [
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Campus",
    value: "campus",
  },
  {
    label: "Evaluators",
    value: "evaluators",
  },
  {
    label: "Students",
    value: "students",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Actions",
    value: "action",
  },
];
export const evaluatorManagementHeader = [
  {
    label: "Evaluator Name",
    value: "name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Campus",
    value: "campus",
  },
  {
    label: "School",
    value: "school",
  },
  {
    label: "Campus Manager",
    value: "campusManager",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "",
    value: "actions",
  },
];
export const specialistManagementHeader = [
  {
    label: "First Name",
    value: "firstName",
    isSortable: true,
  },
  {
    label: "Last Name",
    value: "lastName",
    isSortable: true,
  },
  {
    label: "Email",
    value: "email",
    isSortable: true,
  },
  {
    label: "Campus",
    value: "campuses",
  },
  {
    label: "Status",
    value: "status",
    isSortable: true,
  },
  {
    label: "",
    value: "actions",
  },
];
export const campusManagementHeader = [
  {
    label: "Campus Name",
    value: "name",
    isSortable: true,
  },
  {
    label: "Grade",
    value: "grades",
    isSortable: true,
  },
  {
    label: "Created At",
    value: "createdAt",
    isSortable: true,
  },
  {
    label: "",
    value: "actions",
  },
];
export const schoolAdminManagementHeader = [
  {
    label: "First Name",
    value: "firstName",
    isSortable: true,
  },
  {
    label: "Last Name",
    value: "lastName",
    isSortable: true,
  },
  {
    label: "Email",
    value: "email",
    isSortable: true,
  },
  {
    label: "Status",
    value: "status",
    isSortable: true,
  },
  {
    label: "Created At",
    value: "createdAt",
    isSortable: true,
  },
  {
    label: "",
    value: "actions",
  },
];
export const reports_header = [
  { label: "Grade", value: "grade" },
  { label: "Student Name", value: "studentName" },
  { label: "Assessment Date", value: "date" },
  { label: "Speaking ", value: "speaking" },
  { label: "Writing", value: "writing" },
  { label: "Listening", value: "listening" },
  { label: "Reading", value: "reading" },
  { label: "Overall Score", value: "overallScore" },
];

export const studentStatusOptions = [
  { label: "Active Support", value: studentStatus.ACTIVE_SUPPORT },
  { label: "Inactive Support", value: studentStatus.INACTIVE_SUPPORT },
  { label: "Admission Pending", value: studentStatus.ADMISSION_PENDING },
  { label: "Archive", value: studentStatus.ARCHIVE },
];

export const studentSupportLevelOptions = [
  { label: "High", value: studentSupportLevel.HIGH },
  { label: "Medium", value: studentSupportLevel.MEDIUM },
  { label: "Low", value: studentSupportLevel.LOW },
  { label: "Monitor", value: studentSupportLevel.MONITOR },
  { label: "None", value: studentSupportLevel.NONE },
];
export const campusManagerDetail_EvaluatorHeader = [
  { label: "Evaluator Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Evaluation Assigned", value: "assignedEvaluations" },
  { label: "Completed Evaluations", value: "assignedCompletions" },
  { label: "", value: "actions" },
];
export const FC_Insights_Roster_Headers = [
  { label: "", value: "actions" },
  { label: "Class", value: "name" },
  { label: "Total Students", value: "totalStudents" },
  { label: "Created By", value: "createdBy" },
  { label: "Created At", value: "createdAt" },
];
export const FC_Insights_Student_Headers = [
  { label: "ID", value: "schoolId", isSortable: true },
  { label: "Grade", value: "grade", isSortable: true },
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Home Language", value: "language", isSortable: true },
  { label: "Support", value: "studentSupportLevel", isSortable: true },
  { label: "L", value: "listening", isSortable: true },
  { label: "S", value: "speaking", isSortable: true },
  { label: "R", value: "reading", isSortable: true },
  { label: "W", value: "writing", isSortable: true },
  { label: "Overall", value: "overAllScore", isSortable: true },
  { label: "Status", value: "studentStatus", isSortable: true },
];

export const campusManagerDetail_StudentHeader = [
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Grade", value: "grade", isSortable: true },
  { label: "Home Language", value: "language" },
  { label: "Support Level", value: "studentSupportLevel", isSortable: true },
  { label: "Listening", value: "listening", isSortable: true },
  { label: "Speaking", value: "speaking", isSortable: true },
  { label: "Reading", value: "reading", isSortable: true },
  { label: "Writing", value: "writing", isSortable: true },
  { label: "Overall Score", value: "overAllScore", isSortable: true },
  { label: "Student Status", value: "studentStatus" },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];

export const campusManagerDetail_EvaluationHeader = [
  { label: "Grade", value: "grade" },
  { label: "Student Name", value: "studentName" },
  { label: "Assessment Date", value: "date" },
  { label: "Assessment Purpose", value: "assessmentPurpose" },
  { label: "Speaking Eval Status", value: "status" },
  { label: "Writing Eval Status", value: "status" },
  { label: "", value: "actions" },
];
export const campusManagerDetail_RoasterHeader = [
  { label: "Evaluator Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Date", value: "date" },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];
export const cycleHeaders = [
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Created At",
    value: "createdAt",
  },
  {
    label: "Actions",
    value: "actions",
  },
];

export const statusOptions = [
  { label: "Active", value: STATUS.ACTIVE },
  { label: "Inactive", value: STATUS.INACTIVE },
];
export const statusOptionsWithAll = [
  { label: "All", value: "all" },
  { label: "Active", value: STATUS.ACTIVE },
  { label: "Inactive", value: STATUS.INACTIVE },
];
export const gradeOptions = [
  { label: "3-4", value: GRADE.THREE_TO_FOUR },
  { label: "5-6", value: GRADE.FIVE_TO_SIX },
  { label: "7-8", value: GRADE.SEVEN_TO_EIGHT },
  { label: "9-10", value: GRADE.NINE_TO_TEN },
  { label: "11-12", value: GRADE.ELEVEN_TO_TWELVE },
];

export const assessmentCycleTaskOptions = [
  { label: "FC Summative", value: ASSESSMENT_CYCLE_TASK.SUMMATIVE },
  {
    label: "FC Speaking & Listening",
    value: ASSESSMENT_CYCLE_TASK.LISTENING_SPEAKING,
  },
  {
    label: "FC Reading & Writing",
    value: ASSESSMENT_CYCLE_TASK.READING_WRITING,
  },
];
export const assessmentCyclePurposeOptions = [
  { label: "Admission", value: ASSESSMENT_CYCLE_PURPOSE.ADMISSION },
  { label: "Summative", value: ASSESSMENT_CYCLE_PURPOSE.SUMMATIVE },
  { label: "Screener", value: ASSESSMENT_CYCLE_PURPOSE.SCREENER },
];
export const testSessionCreateStudentHeader = [
  { label: "Grade", value: "grade", isSortable: true },
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Support", value: "studentSupportLevel" },
  { label: "L", value: "listeningScore", isSortable: true },
  { label: "S", value: "speakingScore", isSortable: true },
  { label: "R", value: "readingScore", isSortable: true },
  { label: "W", value: "writingScore", isSortable: true },
  { label: "Overall", value: "overallScore", isSortable: true },
  { label: "Cycle ", value: "cycle" },
  { label: "Accommodation", value: "accommodation" },
  { label: "", value: "action", isSortable: false },
];

export const supportLevelOptionsWithAll = [
  { label: "All", value: "all" },
  ...studentSupportLevelOptions,
];
export const studentStatusOptionsWithAll = [
  { label: "All", value: "all" },
  ...studentStatusOptions,
];
export const studentsSummaryHeader = [
  { label: "ID", value: "schoolId" },
  { label: "Grade", value: "grade" },
  { label: "Student", value: "name" },
  { label: "Support Level", value: "supportLevel" },
  { label: "Status", value: "studentStatus" },
];
export const studentsAssessmentCyclePrepareHeader = [
  {
    label: "ID",
    value: "schoolId",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },

  {
    label: "Grade",
    value: "grade",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "First Name",
    value: "firstName",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Last Name",
    value: "lastName",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Support Level",
    value: "studentSupportLevel",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Status",
    value: "studentStatus",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
];
export const studentsAssessmentCycleConductHeader = [
  {
    label: "ID",
    value: "schoolId",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },

  {
    label: "Grade",
    value: "grade",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "First Name",
    value: "firstName",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Last Name",
    value: "lastName",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Support Level",
    value: "studentSupportLevel",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Student Status",
    value: "status",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Next Test",
    value: "nextDomain",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Accommodations",
    value: "accommodation",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Test Status",
    value: "testStatus",
    isSortable: true,
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Flag",
    value: "flags",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
];
export const quickAssessmentHeader = [
  {
    label: "Student Status",
    value: "status",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Next Test",
    value: "nextDomain",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Accommodations",
    value: "accommodation",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Test Status",
    value: "testStatus",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Flag",
    value: "flags",
    headerStyle: {
      whiteSpace: "nowrap",
    },
  },
];
export const actionsHeader = [
  {
    label: "Action",
    value: "actions",
  },
];
export const accommodationHeader = [
  {
    label: "Accommodation",
    value: "accommodation",
  },
];
export const actionsHeaderWithoutLabel = [
  {
    label: "",
    value: "actions",
  },
];

export const standardizeEvaluationHeaders = [
  { label: "ID", value: "schoolId" },
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Grade",
    value: "grade",
  },
  {
    label: "Support Level",
    value: "studentSupportLevel",
  },
  {
    label: "Evaluator",
    value: "evaluator",
  },
  {
    label: "Speaking Status",
    value: "speakingStatus",
  },
  {
    label: "Writing Status",
    value: "writingStatus",
  },
  {
    label: "Accommodation",
    value: "accommodation",
  },
  {
    label: "",
    value: "actions",
  },
];

export const FCInsightsHeaders = [
  { label: "ID", value: "schoolId" },
  { label: "Student Name", value: "student" },
  { label: "Grade", value: "grade" },
  { label: "Evaluator", value: "evaluator" },
  { label: "Speaking ", value: "speakingScore" },
  { label: "Writing", value: "writingScore" },
  { label: "Listening", value: "listeningScore" },
  { label: "Reading", value: "readingScore" },
  { label: "Overall Score", value: "overallScore" },
  // Domain by domain, as a conductor reads them: a single total hides which
  // sitting was flagged. Vocabulary is left out — it is not shown on this tab.
  { label: "Flags", value: "flags" },
  { label: "Accommodation", value: "accommodations" },
  { label: "", value: "actions" },
];

export const payment_header = [
  {
    label: "Date",
    value: "createdAt",
  },
  {
    label: "Description",
    value: "description",
  },
  {
    label: "Credits",
    value: "credits",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
  },
  {
    label: "Amount",
    value: "amount",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Invoice",
    value: "invoice",
  },
];

export const rostersHeaders = [
  { label: "ID", value: "schoolId", isSortable: true },
  { label: "Grade", value: "grade", isSortable: true },
  { label: "First Name", value: "firstName", isSortable: true },
  { label: "Last Name", value: "lastName", isSortable: true },
  { label: "Support", value: "studentSupportLevel", isSortable: true },
  { label: "L", value: "listening", isSortable: true },
  { label: "S", value: "speaking", isSortable: true },
  { label: "R", value: "reading", isSortable: true },
  { label: "W", value: "writing", isSortable: true },
  { label: "Overall", value: "overall", isSortable: true },
  { label: "Cycle", value: "cycle" },
  { label: "Status", value: "studentStatus", isSortable: true },
  { label: "", value: "action" },
];
export const admissionAssessmentStatusOptions = [
  { label: "Ready", value: ADMISSION_ASSESSMENT_STATUS.READY },
  { label: "In Progress", value: ADMISSION_ASSESSMENT_STATUS.IN_PROGRESS },
  { label: "Completed", value: ADMISSION_ASSESSMENT_STATUS.COMPLETED },
];

export const DATA_REVIEW_SKILL_OPTIONS = [
  {
    label: "Listening",
    value: "listening",
    color: "#163b6e",
    bgColor: "#6FA9C8",
  },
  {
    label: "Speaking",
    value: "speaking",
    color: "#2f6f73",
    bgColor: "#d0f0f2",
  },
  { label: "Reading", value: "reading", color: "#1fa3a6", bgColor: "#9FD4EB" },
  { label: "Writing", value: "writing", color: "#B6393B", bgColor: "#E6A3A5" },
];

export const QUESTION_CRITERIA_OPTIONS = [
  {
    label: "Vocabulary Recognition & Range",
    value: QUESTION_CRITERIA.I1,
  },
  {
    label: "Comprehension of Main Ideas",
    value: QUESTION_CRITERIA.I2,
  },
  {
    label: "Understanding of Details",
    value: QUESTION_CRITERIA.I3,
  },
  {
    label: "Interpretation & Inference",
    value: QUESTION_CRITERIA.I4,
  },
  {
    label: "Language Analysis",
    value: QUESTION_CRITERIA.I5,
  },
];

export const domainVariationsTabsOptions = [
  { label: "L", value: "listening" },
  { label: "S", value: "speaking" },
  { label: "R", value: "reading" },
  { label: "W", value: "writing" },
];

export const LRWSLABELS = {
  VRR: "Vocabulary Recognition & Range",
  CMI: "Comprehension of Main Ideas",
  UOD: "Understanding of Details",
  INI: "Interpretation & Inference",
  LAN: "Language Analysis",
  VWC: "Vocabulary & Word Choice",
  CCO: "Cohesion & Complexity",
  GLU: "Grammar & Language Usage",
  COM: "Comprehensibility",
  CON: "Content",
};

export const criteriaListningReadingHeaders = [
  { label: "", value: "grade" },
  { label: "VRR", value: "VRR", legend: "Vocabulary Recognition & Range" },
  { label: "CMI", value: "CMI", legend: "Comprehension of Main Ideas" },
  { label: "UOD", value: "UOD", legend: "Understanding of Details" },
  { label: "INI", value: "INI", legend: "Interpretation & Inference" },
  { label: "LAN", value: "LAN", legend: "Language Analysis" },
];
export const criteriaSpeakingWritingHeaders = [
  { label: "", value: "grade" },
  { label: "VWC", value: "VWC", legend: "Vocabulary & Word Choice" },
  { label: "CCO", value: "CCO", legend: "Cohesion & Complexity" },
  { label: "GLU", value: "GLU", legend: "Grammar & Language Usage" },
  { label: "COM", value: "COM", legend: "Comprehensibility" },
  { label: "CON", value: "CON", legend: "Content" },
];
export const domainVariationsTableHeaders = [
  { label: "Grade", value: "grade" },
  { label: "Median", value: "median" },
  { label: "IQR Range", value: "iqr" },
  { label: "Variation Level", value: "variationLevel" },
];

export const learningLanguagesOptions = [
  { label: "Arabic", value: "arabic" },
  { label: "Bahasa Indonesia", value: "bahasa_indonesia" },
  { label: "Bahasa Malaysia", value: "bahasa_malaysia" },
  { label: "Bengali", value: "bengali" },
  { label: "Burmese", value: "burmese" },
  { label: "Chinese – Cantonese", value: "cantonese" },
  { label: "Chinese – Hakka", value: "hakka" },
  { label: "Chinese – Mandarin", value: "mandarin" },
  { label: "Chinese – Other", value: "chinese_other" },
  { label: "Chinese – Shanghainese/Wu", value: "shanghainese_wu" },
  { label: "Chinese – Sichuanese", value: "sichuanese" },
  { label: "Dutch", value: "dutch" },
  { label: "English", value: "english" },
  { label: "Farsi", value: "farsi" },
  { label: "French", value: "french" },
  { label: "German", value: "german" },
  { label: "Hebrew", value: "hebrew" },
  { label: "Hindi", value: "hindi" },
  { label: "Italian", value: "italian" },
  { label: "Japanese", value: "japanese" },
  { label: "Javanese", value: "javanese" },
  { label: "Khmer", value: "khmer" },
  { label: "Korean", value: "korean" },
  { label: "Madurese", value: "madurese" },
  { label: "Malay", value: "malay" },
  { label: "Portuguese (Brazilian)", value: "portuguese_brazilian" },
  { label: "Portuguese (European)", value: "portuguese_european" },
  { label: "Russian", value: "russian" },
  { label: "Spanish", value: "spanish" },
  { label: "Sudanese", value: "sudanese" },
  { label: "Swedish", value: "swedish" },
  { label: "Tagalog", value: "tagalog" },
  { label: "Thai", value: "thai" },
  { label: "Turkish", value: "turkish" },
  { label: "Urdu", value: "urdu" },
  { label: "Vietnamese", value: "vietnamese" },
  // Catch-all stays last, after the alphabetized languages.
  { label: "Other", value: "other" },
];
export const otherLanguagesOptions = [
  ...learningLanguagesOptions,
  { label: "None", value: "none" },
];

export const languageSupportLevelOptions = [
  { label: "Strongly disagree", value: 1 },
  { label: "Disagree", value: 2 },
  { label: "Neutral", value: 3 },
  { label: "Agree", value: 4 },
  { label: "Strongly agree", value: 5 },
  { label: "No Response", value: 0 },
];

export const howILearnBestOptions = {
  general: [
    "Seeing some key words in my home language during lessons helps me.",
    "Using translation tools (like a dictionary or app) helps me.",
    "Previewing (seeing) new words before class helps me.",
    "Taking notes in class so I can study them later.",
    "Time to discuss new information with my group.",
    "Other",
  ],
  reading: [
    "Reading about new topics in my home language helps me",
    "Using a glossary with words in different languages helps me.",
    "Having someone read out loud to me as I follow along.",
    "Other",
  ],
  writing: [
    "Seeing an example of what I need to write.",
    "Using a word bank so I know what to write.",
    "Having sentence starters or examples helps me write.",
    "Other",
  ],
  speaking: [
    "Practice speaking with a partner before sharing with the class.",
    "Discussing in my home language before speaking in English.",
    "Having time to think before I speak in a group or to the whole class.",
    "Other",
  ],
  listening: [
    "Watching a video before or during class helps me.",
    "Drawing pictures or diagrams while listening helps me understand.",
    "Having the keywords stated multiple times so I can remember them.",
    "Other",
  ],
};

export const dashboard_cards_data = [
  { label: "Active Support", value: 0 },
  { label: "Inactive Support", value: 0 },
  { label: "Admissions Pending", value: 0 },
  { label: "Remaining Assessments", value: 0 },
];

export const timeExtensionOptions = [
  { label: "None", value: TIME_EXTENSION_TYPE.NONE },
  { label: "+ 5 minutes", value: TIME_EXTENSION_TYPE.FIVE_MINUTES },
  { label: "+ 10 minutes", value: TIME_EXTENSION_TYPE.TEN_MINUTES },
  { label: "+ 20 minutes", value: TIME_EXTENSION_TYPE.TWENTY_MINUTES },
  { label: "Timer Removed", value: TIME_EXTENSION_TYPE.INFINITE },
];

export const fcInsightsSubTabs = [
  // overview
  // domain
  // criteria
  {
    label: "Overview",
    value: "overview",
  },
  {
    label: "Domain",
    value: "domain",
  },
  {
    label: "Criteria",
    value: "criteria",
  },
  {
    label: "Compass",
    value: "aiCompass",
  },
];

// "#163b6e",
// "#Bf8b1a",
// "#6f8f7a",
// "#2f6f73",
// "#e1b955",
// "#5c7a7d",
// "#b0a58f",
// "#4caf84",
// "#5f6f82",
// "#c26a2e",
// "#1fa3a6",
// "#8b6a4f",
// "#b7705b",
export const supportColors = {
  "active-support": {
    bg: "#6f8f7a",
    color: "#fff",
  },
  "inactive-support": {
    bg: "#e1b955",
    color: "#fff",
  },
  total: {
    bg: "#9bb7c8",
    color: "#fff",
  },
};
export const gradeOptionsDigits = [
  { label: "Grade 3", value: 3 },
  { label: "Grade 4", value: 4 },
  { label: "Grade 5", value: 5 },
  { label: "Grade 6", value: 6 },
  { label: "Grade 7", value: 7 },
  { label: "Grade 8", value: 8 },
  { label: "Grade 9", value: 9 },
  { label: "Grade 10", value: 10 },
  { label: "Grade 11", value: 11 },
  { label: "Grade 12", value: 12 },
];

export const ACCOMMODATION_ICONS = {
  time_extension: { Icon: FaClock, title: "Time extension", color: "#163b6e" },
  read_instructions: {
    Icon: FaBookOpen,
    title: "Read instructions",
    color: "#b0a58f",
  },
  read_questions: {
    Icon: FaFileLines,
    title: "Read questions",
    color: "#1fa3a6",
  },
  handwritten_answer: {
    Icon: FaPen,
    title: "Handwritten answer",
    color: "#b7705b",
  },
  assistance: {
    Icon: FaHandHoldingHeart,
    title: "Assistance",
    color: "#5f6f82",
  },
  small_group: { Icon: FaUsers, title: "Small group", color: "#c26a2e" },
  scribe: { Icon: FaPenToSquare, title: "Scribe", color: "#4caf84" },
};

export const cycleFormatOptions = [
  { label: "Academic Year (Fall - Spring)", value: "academic" },
  { label: "Calendar Year (January - December)", value: "calendar" },
];

export const assessmentTypeOptions = [
  { label: "Cycle", value: "cycle" },
  { label: "Admissions", value: "admission" },
];
export const gradeOptionsWithAll = [
  { label: "All", value: "all" },
  ...gradeOptionsDigits,
];
